// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"challenge-form_tabContent_3PZ2E"};